import script from "./SupplierMap.vue?vue&type=script&lang=js"
export * from "./SupplierMap.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__